import React, { Component } from 'react';
import * as _ from 'lodash';
import Validator from 'validatorjs';
import { Row, Col } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import { TipoDeRelacion } from '../../../../support/catalogs/TipoDeRelacion';

class CfdisRelacionadosForm extends Component {

  state = {}

  tipoDeRelacionCatalog = [];

  constructor(props) {
    super(props);

    const catalog = TipoDeRelacion.map(item => {
      return {
        label: `${item.descripcion} (${item.clave})`,
        value: item.clave
      }
    });

    this.tipoDeRelacionCatalog = _.sortBy(catalog, 'label');

    this.state = {
      validator: new Validator({}, this.rules),
      data: props.data || {},
      isValid: false
    }
  }

  get rules() {
    return {
      'TipoRelacion': ['required'],
      'cfdis': ['required'],
    }
  }

  get catalog() {
    return [{
      label: 'Selecciona',
      value: ''
    }].concat(this.tipoDeRelacionCatalog);
  }

  componentDidUpdate() {
    if (!this.state.data.TipoRelacion && !!this.props.data.TipoRelacion) {
      this.setState({
        data: {
          ...this.props.data
        }
      });
    }
  }


  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
      isValid: validator.passes()
    });

    return validator;
  }

  handleOnChange = (event) => {
    const data = {
      ...this.state.data,
      ...event
    };

    this.validate(data);

    this.setState({
      data
    });
  }

  handleOnCfdisRelacionadosChange = (event) => {
    const { name, checked} = event.target;
    const { data, data: { Metadata = {}, CfdiRelacionados = {} }} = this.props;

    this.props.onChange({
      ...data,
      Metadata: {
        ...Metadata,
        [name]: checked
      },
      CfdiRelacionados: checked === true ? CfdiRelacionados : undefined
    });

    this.validate(checked ? this.state.data : {});

    if (!checked) {
      this.setState({
        data: {}
      });
    }
  }

  handleOnCfdiSearchClick = () => {
    const uuids = this.state.data.cfdis.toString().split("\n").map((item) => item.trim())
      .filter(item => /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(item))
      .map((item) => {
        return {
          'UUID': item
        };
      });

    this.props.onChange({
      CfdiRelacionados: {
        'TipoRelacion': this.state.data.TipoRelacion,
        'CfdiRelacionado': [ ...uuids ]
      }
    });
  }

  render() {
    const { data, isValid } = this.state;
    const rules = this.rules;

    return (
      <>
        <Row>
          <Col>
            <FormControl type="select"
              label="Tipo de relación"
              name="TipoRelacion"
              placeholder=""
              help=""
              rules={ rules.TipoRelacion }
              value={ data.TipoRelacion }
              options={ this.catalog }
              onChange={ this.handleOnChange }
            />

            <FormControl as="textarea"
              label="CFDIs"
              name="cfdis"
              placeholder=""
              help=""
              rules={ rules.cfdis }
              value={ data.cfdis }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col>

          </Col>
        </Row>

        <Row>
          <Col>
            <LoadingButton
            variant="secondary"
            disabled={ !isValid }
            onClick={ this.handleOnCfdiSearchClick }>
              Agregar CFDIs
            </LoadingButton>
          </Col>
        </Row>
      </>
    )
  }
}

export default CfdisRelacionadosForm;